import React, { useContext } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import MessageModal from '@wix/da-ds/pkg/modals/dsPresets/MessageModal';
import { CancelButton } from '@wix/da-ds/pkg/modals/dsPresets/MessageModal/buttons';
import { MODAL_FOOTER_BUTTON_SIZE } from '@wix/da-ds/pkg/modals/dsPresets/Modal';
import BuyCoreBrandedButton from '../../../../../Button/core/dsPresets/BuyCoreBrandedButton';
import BoostIllustration from '../BoostIllustration';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { BiData, BuyCoreButtonBiEvent } from '@wix/da-bi/pkg/events';
import { ReferralType } from '@wix/da-bi/pkg/constants';

interface Props {
  isTier?: boolean;
  onRequestClose: () => void;
}

const BoostUpgradeCoreModal: React.FC<Props> = ({ isTier, onRequestClose }) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);

  return (
    <MessageModal
      isOpen
      onRequestClose={onRequestClose}
      image={<BoostIllustration />}
      variant={isMobile ? 'vertical' : 'horizontal'}
      title={t('boostDeviation.modal.title.upgradeCore')}
      message={
        <Trans i18nKey={`boostDeviation.modal.message.upgradeCore${isTier ? '.tier' : ''}`}>
          Core+ Memberships and above give you free monthly boosts to make your\ndeviation more
          visible in other deviants’ browse feeds.{' '}
          <a
            target="_blank"
            className="link"
            href={t('boostDeviation.learnMoreUrl')}
            rel="noreferrer"
          >
            Learn more
          </a>
        </Trans>
      }
      footerButtons={[
        <CancelButton key="cancel" onClick={onRequestClose}>
          {t('popup.cancel')}
        </CancelButton>,
        <BuyCoreBrandedButton
          key="buy-core"
          size={MODAL_FOOTER_BUTTON_SIZE}
          biData={BiData<BuyCoreButtonBiEvent>({
            evid: 375,
            referral_info: ReferralType.BOOST_UPGRADE_CORE_POPUP,
          })}
        >
          {t('common.upgradeNow')}
        </BuyCoreBrandedButton>,
      ]}
    />
  );
};
BoostUpgradeCoreModal.displayName = 'BoostUpgradeCoreModal';

export default BoostUpgradeCoreModal;
